import { render, staticRenderFns } from "./provider.vue?vue&type=template&id=f0952c56&scoped=true&"
var script = {}
import style0 from "./provider.vue?vue&type=style&index=0&id=f0952c56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0952c56",
  null
  
)

export default component.exports